export default "__VITE_ASSET__d3c04518__"